// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uIZw","index":"styles_index__1BttJ"};